export interface PigQueryParams {
  previouslyPigged?: number;
  pipeSizeId?: number;
  pigPurposeId?: number;
  pipelineServiceId?: number;
  waxParaffin?: boolean;
  bodyBypassRequired?: boolean;
  bidirectional?: boolean;
  efficiencyEffectiveness?: number;
  aggressivenessRisk?: number;
}

export function pigQueryParamsFactory(obj: Partial<PigQueryParams>): PigQueryParams {
  return {
    previouslyPigged: obj.previouslyPigged || -1,
    pipeSizeId: obj.pipeSizeId,
    pigPurposeId: obj.pigPurposeId,
    pipelineServiceId: obj.pipelineServiceId,
    waxParaffin: obj.waxParaffin,
    bodyBypassRequired: obj.bodyBypassRequired,
    bidirectional: obj.bidirectional || false,
    efficiencyEffectiveness: obj.efficiencyEffectiveness,
    aggressivenessRisk: obj.aggressivenessRisk
  }
}

// Generated by https://quicktype.io

export interface PigQueryResult {
  familyId: number;
  familyName: string;
  configurationId: number;
  configurationName: string;
  productId?: number;
  partNumber: string;
  productName: string;
  diameter: number;
  diameterText: string;
  linePiggedPreviously: boolean;
  realSealCup: number;
  bidirectional: boolean;
  minimumMetal: boolean;
  bodyBypass: boolean;
  rebuildable: boolean;
  minBendRadiusId: number;
  minBendRadiusText: string;
  coatedPipe: boolean;
  waxParaffin: boolean;
  durometerId: number;
  durometerText: string;
  bypassHoleRequirementId: number;
  bypassHoleRequirementText: string;
  gaugePlateSizeId: number;
  gaugePlateSizeText: string;
  magnet: boolean;
  operatingTemp: string;
  flowSpeed: string;
  maxRunLength: string;
  productPh: string;
  drawing: string;
  picture: string;
  techAssistanceRequired: boolean;
  preferredProduct: boolean;
}

// Generated by https://quicktype.io

export interface ProductInformation {
  id: number;
  productID: number;
  name: string;
  englishValue: string;
  englishUOM: string;
  metricValue: string;
  metricUOM: string;
  sortOrder: number;
}

// Generated by https://quicktype.io

export interface PigAccessory {
  id: number;
  productId: number;
  accessoryTypeId: number;
  description: string;
  partNumber: string;
  required: boolean;
  sortOrder: number;
}

// Generated by https://quicktype.io

export interface BypassInformation {
  productID: number;
  numberHoles: number;
  holeDiameter: string;
}

// Generated by https://quicktype.io

export interface ReplacementPart {
  bomid: string;
  lineNum: number;
  itemID: string;
  itemName: string;
  quantity: number;
}

// Generated by https://quicktype.io

export interface PigComponent {
  id: number;
  productID: number;
  itemNumber: string;
  componentTypeID: number;
  description: string;
  quantity: number;
}

// Generated by https://quicktype.io

export interface PigAssociatedProduct {
  id: number;
  pigProductID: number;
  associatedProductID: number;
  associatedProductTypeID: number;
  text: string;
  description: string;
  productNumber: string;
  notes: string;
  sortOrder: number;
  hasDrawing: boolean;
}


// Generated by https://quicktype.io

export interface PigBulletin {
  productFamilyID: number;
  piggingPurposeID: number;
  bulletinURL: string;
}
